var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailoredFeature2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.25 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#019cae;}.cls-1,.cls-3,.cls-5{fill-rule:evenodd;}.cls-3,.cls-4{fill:#fff;}.cls-5{fill:#c0cdea;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    className: "cls-1",
    d: "M83.78,82.83l-11,9.64a1.21,1.21,0,0,0-.11,1.72.65.65,0,0,0,.17.16l18.39,14.36a1.22,1.22,0,0,0,2-1v-24A1.23,1.23,0,0,0,92,82.53H84.59A1.15,1.15,0,0,0,83.78,82.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1766",
    "data-name": "Rectangle 1766",
    className: "cls-2",
    d: "M19.64,1.05H223a7,7,0,0,1,7,7V89.35a7,7,0,0,1-7,7H19.64a7,7,0,0,1-7-7h0V8a7,7,0,0,1,7-6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    className: "cls-3",
    d: "M191.28,69.76A19.32,19.32,0,1,0,172,50.44,19.32,19.32,0,0,0,191.28,69.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1767",
    "data-name": "Rectangle 1767",
    className: "cls-4",
    d: "M25.34,34.57H160.25a1.25,1.25,0,0,1,1.25,1.25h0a1.25,1.25,0,0,1-1.25,1.25H25.34a1.25,1.25,0,0,1-1.25-1.25h0a1.25,1.25,0,0,1,1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    className: "cls-3",
    d: "M160.12,40.48H25.47a1.32,1.32,0,0,0-1.37,1.25h0A1.32,1.32,0,0,0,25.47,43H160.12a1.32,1.32,0,0,0,1.38-1.25h0A1.33,1.33,0,0,0,160.12,40.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1768",
    "data-name": "Rectangle 1768",
    className: "cls-4",
    d: "M25.34,46.4H160.25a1.25,1.25,0,0,1,1.25,1.24h0a1.25,1.25,0,0,1-1.25,1.25H25.34a1.25,1.25,0,0,1-1.25-1.25h0A1.25,1.25,0,0,1,25.34,46.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    className: "cls-4",
    d: "M25.34,52.31H160.25a1.25,1.25,0,0,1,1.25,1.25h0a1.25,1.25,0,0,1-1.25,1.25H25.34a1.25,1.25,0,0,1-1.25-1.25h0A1.25,1.25,0,0,1,25.34,52.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1770",
    "data-name": "Rectangle 1770",
    className: "cls-4",
    d: "M111.57,58.22h48.68a1.25,1.25,0,0,1,1.25,1.25h0a1.25,1.25,0,0,1-1.25,1.25H111.57a1.24,1.24,0,0,1-1.24-1.25h0A1.24,1.24,0,0,1,111.57,58.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    className: "cls-4",
    d: "M98.78,58.22h2.1a1.25,1.25,0,0,1,1.25,1.25h0a1.25,1.25,0,0,1-1.25,1.25h-2.1a1.25,1.25,0,0,1-1.25-1.25h0A1.25,1.25,0,0,1,98.78,58.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    className: "cls-5",
    d: "M184.49,64.61,183,63.13a3.25,3.25,0,0,0-.47.36A15.59,15.59,0,0,0,184.49,64.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    className: "cls-5",
    d: "M184.49,64.61,183,63.13a2.67,2.67,0,0,0-.47.36A15.59,15.59,0,0,0,184.49,64.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    className: "cls-5",
    d: "M198,64.62l1.53-1.49a3.17,3.17,0,0,1,.46.36A16.2,16.2,0,0,1,198,64.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    className: "cls-5",
    d: "M198,64.62l1.53-1.49a2.6,2.6,0,0,1,.46.36A16.2,16.2,0,0,1,198,64.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    className: "cls-5",
    d: "M196.56,61.92l.13,0h0a15.17,15.17,0,0,1,2.87,1.17,2.22,2.22,0,0,1,.44.37,15.81,15.81,0,0,1-17.47,0,2,2,0,0,1,.44-.37A14.65,14.65,0,0,1,185.84,62h0l.12,0h0a15.88,15.88,0,0,1,2.17-.27l3.08.45h.08l3.08-.45a15.69,15.69,0,0,1,2.17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    className: "cls-5",
    d: "M193.79,54.88l-.08,1.73V60.7a1.56,1.56,0,0,0,.67,1c-2.22,2.41-4,2.41-6.24,0a1.49,1.49,0,0,0,.67-1V56.61l-.07-1.73s1.24.22,2.52.54C192.55,55.1,193.79,54.88,193.79,54.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    className: "cls-5",
    d: "M183.23,45.13a4,4,0,0,0-.38,1.49c0,.72,1.52,1,2,1s14.46.52,14.46.52a.53.53,0,0,0,.43-.5c0-.42-2.39-5.63-2.39-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    className: "cls-5",
    d: "M183.66,49.56a2.22,2.22,0,1,1-2.22,2.22h0a2.21,2.21,0,0,1,2.22-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    className: "cls-5",
    d: "M198.91,49.56a2.22,2.22,0,1,1-2.22,2.22h0A2.21,2.21,0,0,1,198.91,49.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    className: "cls-5",
    d: "M191.32,37.79h0a7.62,7.62,0,0,1,7.6,7.6V52.3a7.62,7.62,0,0,1-7.6,7.6h0a7.63,7.63,0,0,1-7.61-7.6V45.39A7.63,7.63,0,0,1,191.32,37.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    className: "cls-5",
    d: "M198.05,45.28v2.38c0,.94.17,1.21.63,1.55,0,0-.28.91.24,1.12a.84.84,0,0,1,.41-.7V43.84a3.17,3.17,0,0,1-1.34.91A2.33,2.33,0,0,1,198.05,45.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    className: "cls-5",
    d: "M184.64,44.88V46.6c0,.67-.12.87-.46,1.12,0,0-.09.57-.46.72l-.34-4.51a3.67,3.67,0,0,0,1.3.56A1.72,1.72,0,0,0,184.64,44.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    className: "cls-5",
    d: "M199.78,47.65a6.57,6.57,0,0,0-1.73-1.42h0l-.21-.12a4.48,4.48,0,0,1-1.8-1.76c-.63.43-3.22.36-4.2.32h-.38c-4.34-.18-8.55.88-8.57,2-3.76-7.91,5.65-15.53,14-6.89C201.3,40,200.91,44.49,199.78,47.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredFeature2);
export default __webpack_public_path__ + "static/media/tailoredFeature2.92c5dc0162d96e1b9f053b735027b709.svg";
export { ForwardRef as ReactComponent };